import React, { useState } from 'react';
import { action } from '@storybook/addon-actions';
import { withKnobs, boolean, select, text } from '@storybook/addon-knobs';
import InlineLoading from 'carbon-components-react/lib/components/InlineLoading';
import { settings } from 'carbon-components';
import ComposedModal, {
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'carbon-components-react/lib/components/ComposedModal';
import { Button } from 'carbon-components-react';

const { prefix } = settings;

const sizes = {
  Default: '',
  'Extra small (xs)': 'xs',
  'Small (sm)': 'sm',
  'Large (lg)': 'lg',
};




const props = {
    composedModal: ({ titleOnly } = {}) => ({
      open: boolean('Open (open in <ComposedModal>)', true),
    //   onKeyDown: action('onKeyDown'),
      danger: boolean('Danger mode (danger)', false),
      selectorPrimaryFocus: text(
        'Primary focus element selector (selectorPrimaryFocus)',
        '[data-modal-primary-focus]'
      ),
      size: select('Size (size)', sizes, titleOnly ? 'sm' : ''),
      preventCloseOnClickOutside: boolean(
        'Prevent closing on click outside of modal (preventCloseOnClickOutside)',
        false
      ),
    }),
    composedModalWithLauncher: ({ titleOnly } = {}) => ({
    //   onKeyDown: action('onKeyDown'),
      danger: boolean('Danger mode (danger)', false),
      selectorPrimaryFocus: text(
        'Primary focus element selector (selectorPrimaryFocus)',
        '[data-modal-primary-focus]'
      ),
      size: select('Size (size)', sizes, titleOnly ? 'sm' : ''),
    }),
    modalHeader: ({ titleOnly } = {}) => ({
      label: text('Optional Label (label in <ModalHeader>)', ''),
      title: text(
        'Optional title (title in <ModalHeader>)',
        titleOnly
          ? `
        Passive modal title as the message. Should be direct and 3 lines or less.
      `.trim()
          : ''
      ),
      iconDescription: text(
        'Close icon description (iconDescription in <ModalHeader>)',
        'Close'
      ),
      buttonOnClick: action('buttonOnClick'),
      preventCloseOnClickOutside: boolean(
        'Prevent closing on click outside of modal (preventCloseOnClickOutside)',
        false
      ),
    }),
    modalBody: () => ({
      hasScrollingContent: boolean(
        'Modal contains scrollable content (hasScrollingContent)',
        true
      ),
      'aria-label': text('ARIA label for content', 'Example modal content'),
    }),
    modalFooter: () => ({
      primaryButtonText: text(
        'Primary button text (primaryButtonText in <ModalFooter>)',
        'Approve'
      ),
      primaryButtonDisabled: boolean(
        'Primary button disabled (primaryButtonDisabled in <ModalFooter>)',
        false
      ),
      secondaryButtonText: text(
        'Secondary button text (secondaryButtonText in <ModalFooter>)',
        'cancel'
      ),
      onRequestClose: action('onRequestClose'),
      onRequestSubmit: action('onRequestSubmit'),
    }),
  };

  
  /**
   * Simple state manager for modals.
   */

  
export const ModalComponentWithInlineLoading = (param) => {
    const { size, ...rest } = props.composedModal();
    const { hasScrollingContent, ...bodyProps } = props.modalBody();
    return (
      <ComposedModal {...rest} size={size || undefined}>
        <ModalHeader buttonOnClick={param.onClickSecondary}>
          
        </ModalHeader>
        { <ModalBody
          {...bodyProps}
          aria-label={hasScrollingContent ? 'Modal content' : undefined}>
          <p className="carbon-display-Regular-28">
            {param.children}
          </p>
          <br />
        </ModalBody> }
        <ModalFooter>
        <Button kind={param.modalFooter.primaryButtonKind} disabled = {param.isSubmitting || param.success} onClick ={param.onClick}>{param.modalFooter.primaryButtonText}</Button>
       {/* { param.children === "Insufficient Privileges,Please Contact Your System Administrator." ? '' : <Button kind={param.modalFooter.secondaryButtonKind} onClick ={param.onClickSecondary}>{param.modalFooter.secondaryButtonText}</Button>} */}
       {param.isSubmitting || param.success ? (
            <InlineLoading
              style={{ marginLeft: '1rem' }}
              description={param.description}
              status={param.success ? 'finished' : 'active'}
              aria-live={param.ariaLive}
            />
          ) : (
            <Button kind={param.modalFooter.secondaryButtonKind} onClick={param.onClickSecondary}>{param.modalFooter.secondaryButtonText}</Button>
          )}

          <div>    
  </div>
        </ModalFooter>
      </ComposedModal>
    );
        }
